var i18n = require('i18n')
var downloadExport = require('../utils/download-export')

module.exports = Em.Controller.extend({
    needs: ['user'],

    organization: Em.computed.alias('controllers.user.activeOrganization'),

    segment: Em.inject.service(),

    api: Ember.inject.service(),

    openExport: function(url, params) {
        var api = this.container.lookup('api:billy')

        params = _.merge({
            accessToken: api.storageAdapter.getValue('accessToken'),
            acceptLanguage: i18n.locale()
        }, params)

        var exportUrl = url + '?' + $.param(params)

        downloadExport(this.container, exportUrl)
    },

    sendExportEvent: function(exportType, format, period) {
        period = period ? period.value : 'all'

        // Remove organization id from the name of the event (should be fiscalyear:YYYY, instead of fiscalyear:ID,YYYY)
        if (period.startsWith('fiscalyear')) {
            period = 'fiscalyear:' + period.slice(-4)
        }

        this.get('segment').track('XXX - Mikkel - Exports', {
            export_type: exportType,
            file_format: format,
            period: period
        })
    },

    actions: {
        exportChartOfAccounts: function(format) {
            format = format || 'xlsx'
            this.openExport('/organizations/' + this.get('organization.id') + '/chartOfAccounts.' + format)
            this.sendExportEvent('Chart of accounts', format)
        },

        exportDaybook: function(daybookId, format) {
            format = format || 'xlsx'
            this.openExport('/organizations/' + this.get('organization.id') + '/daybooks/' + daybookId + '.' + format)
            this.sendExportEvent('Daybook', format)
        },

        exportContacts: function(format) {
            format = format || 'xlsx'
            this.openExport('/organizations/' + this.get('organization.id') + '/contacts.' + format)
            this.sendExportEvent('Contacts', format)
        },

        exportProducts: function(format) {
            format = format || 'xlsx'
            this.openExport('/organizations/' + this.get('organization.id') + '/products.' + format)
            this.sendExportEvent('Products', format)
        }
    }
})
